export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/a92d826d80900dda6092d3b109ffaee1.svg";